module.exports = __webpack_public_path__ + "img/profile-aside.20114319.jpg";